"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computed = void 0;
const index_js_1 = require("../lifecycle/index.js");
const index_js_2 = require("../atom/index.js");
let computed = (stores, cb) => {
    if (!Array.isArray(stores))
        stores = [stores];
    let diamondNotifyId;
    let diamondArgs = [];
    let run = () => {
        let args = stores.map(store => store.get());
        if (diamondNotifyId !== index_js_2.notifyId ||
            args.some((arg, i) => arg !== diamondArgs[i])) {
            diamondNotifyId = index_js_2.notifyId;
            diamondArgs = args;
            derived.set(cb(...args));
        }
    };
    let derived = (0, index_js_2.atom)();
    (0, index_js_1.onMount)(derived, () => {
        let unbinds = stores.map(store => store.listen(run, cb));
        run();
        return () => {
            for (let unbind of unbinds)
                unbind();
        };
    });
    return derived;
};
exports.computed = computed;
